import { useCallback } from 'react'
import { usePostHog } from 'posthog-js/react'

export type AnalyticsEvent = 
  | 'event_zero'
  | 'recruitment_exposure_toggled_on'
  | 'recruitment_exposure_toggled_off'

type EventPropertiesMap = {
  event_zero: {
    message: string
  }
}

export type FeatureFlag =
  | 'recruitment-exposure-setting'

type FeatureFlagReturnMap = {
  'recruitment-exposure-setting': 'test' | 'control'
}

/* 
To override feature flags for testing: (in file scope, not in component scope)
posthog.featureFlags.overrideFeatureFlags({ flags: { 'recruitment-exposure-setting': 'test' } })
*/

export const useAnalytics = () => {
  const posthog = usePostHog()

  const capture = useCallback(<E extends AnalyticsEvent>(
    event: E,
    properties?: E extends keyof EventPropertiesMap ? EventPropertiesMap[E] : undefined
  ) => {
    posthog.capture(event, properties)
  }, [posthog])

  const getFlag = useCallback(<F extends FeatureFlag>(flagName: F, defaultValue?: FeatureFlagReturnMap[F]): FeatureFlagReturnMap[F] | undefined => {
    return posthog.getFeatureFlag(flagName) as FeatureFlagReturnMap[F] | undefined || defaultValue
  }, [posthog])

  return { capture, getFlag }
}

